module.exports = __webpack_public_path__ + "img/3_better_checkerboards.29709ca9.png";